<template>
  <Page>
    <sort-dialog
      v-model="showSortDialog"
      @sorted="showSortDialog = false; fetchData(1)"
    />
    <div
      v-if="loading"
      class="text-xs-center my-5 pt-5"
    >
      <v-progress-circular
        :size="50"
        color="black"
        indeterminate
      />
    </div>

    <div v-else>
      <v-layout row>
        <v-flex>
          <h1>{{ $t('ACCOUNT.PUBLISED_ARTWORKS') }}</h1>
        </v-flex>
        <v-flex text-xs-right>
          <tk-btn
            dark
            small
            @click="showSortDialog = true"
          >
            <v-icon
              class="mr-2"
              left
              size="16"
            >fas fa-list
            </v-icon>
            <span>{{ $t('ACCOUNT.SORT_ARTWORKS') }}</span>
          </tk-btn>
          <tk-btn
            dark
            small
            :to="{ name: 'profile.artworks.edit'}"
          >
            <v-icon
              class="mr-2"
              left
              size="16"
            >fas fa-plus
            </v-icon>
            {{ $t('ACCOUNT.NEW_ARTWORK') }}
          </tk-btn>
        </v-flex>
      </v-layout>

      <masonry
        :cols="{default: 3, 1200: 2, 960: 1}"
        :gutter="40"
      >
        <tk-artwork
          v-for="artwork in artworks"
          class="mb-4"
          :key="artwork.id"
          :artwork="artwork"
          :artist="$auth.currentUser"
          :clickable="canViewArtwork(artwork)"
        >
          <template v-slot:action-btns>
            <v-divider/>
            <v-card-actions class="pa-0">
              <tk-btn
                flat
                block
                :to="{ name: 'profile.artworks.edit', params: {artworkId: artwork.id}}"
                :disabled="artwork.cloning || artwork.unhiding"
              >
                <span>{{ $t('ACCOUNT.EDIT') }}</span>
              </tk-btn>

              <tk-btn
                block
                :disabled="artwork.unhiding"
                :loading="artwork.cloning"
                flat
                @click="clone(artwork)"
              >{{ $t('ACCOUNT.CLONE') }}
              </tk-btn>

              <tk-btn
                v-if="!artwork.is_visible"
                block
                :disabled="artwork.cloning"
                :loading="artwork.unhiding"
                flat
                @click="unhide(artwork)"
              >{{ $t('ACCOUNT.UNHIDE') }}
              </tk-btn>
            </v-card-actions>
          </template>
        </tk-artwork>
      </masonry>

      <div
        class="text-xs-right mt-4"
        v-if="artworks.length"
      >
        <v-pagination
          @input="fetchData"
          :disabled="loading"
          :value="pagination.currentPage"
          :length="pagination.lastPage"
          :total-visible="7"
        />
      </div>
    </div>
  </Page>
</template>

<script>
import { RepositoryFactory } from '@/services/RepositoryFactory'
import { ErrorHandler } from '@/utils/ErrorHandler'
import Page from '../../../components/base/Page/Page'
import { ArtistStatus } from '../../../services/artist/ArtistStatus'

const artworksRepo = RepositoryFactory.artworks()
const handler = new ErrorHandler()

export default {
  components: {
    Page,
    SortDialog: () => import('./SortDialog')
  },

  data () {
    return {
      showSortDialog: false,
      artworks: [],
      pagination: {},
      loading: true
    }
  },

  created () {
    this.fetchData(1)
  },

  methods: {
    canViewArtwork (artwork) {
      const currentUser = this.$auth.currentUser
      const artistApproved = artwork.artist  && artwork.artist.status === ArtistStatus.Approved
      return !artwork.artist || artistApproved || (currentUser && currentUser.isAdmin) || false
    },

    async fetchData (page) {
      this.loading = true
      await handler.handle(async () => {
        const res = await artworksRepo.profilePublishedArtworks(page)
        console.log(res)

        this.artworks = res.data
        this.pagination = res.pagination
      })
      this.loading = false
    },

    async unhide (artwork) {
      artwork.unhiding = true
      try {
        await artworksRepo.unhideArtwork(artwork.id)
        artwork.is_visible = true
      } catch (error){
        const errors = error.data.errors
        this.$app.toast(errors && errors.artworks && errors.artworks[0], 5000, "error");
        console.log(error)
      }

      artwork.unhiding = false
    },

    async clone (artwork) {
      artwork.cloning = true

      await handler.handle(async () => {
        const res = await artworksRepo.cloneArtwork(artwork.id)
        console.log({ res })
        await this.$auth.refresh()

        this.$router.push({
          name: 'profile.artworks.edit',
          params: { artworkId: res.id }
        })
      })

      artwork.cloning = false
    }
  }
}
</script>
